import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  freeBetStore,
  SlowConnectionWr,
  BetNotificationWr,
  ConnectionPopupsWr,
  UnderMaintenanceWr,
} from '@pascal/pascal-core';

import { minOdd } from '../../../enums';
import GameMain from '../../../components/common/GameMain';

const Game = observer(() => {
  const { activeFreeBet } = freeBetStore;
  return (
    <div className='monti-game-holder'>
      <GameMain />
      <BetNotificationWr
        translationDynamicValues={{
          value: `x${activeFreeBet?.id ? activeFreeBet.minOdd : minOdd}`,
        }}
      />
      <UnderMaintenanceWr />
      <SlowConnectionWr />
      <ConnectionPopupsWr />
    </div>
  );
});

export default Game;
